import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "asd__mobile-header asd__mobile-only"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = {
  key: 1,
  class: "asd__mobile-close-icon",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "asd__datepicker-header" }
const _hoisted_6 = { class: "asd__change-month-button asd__change-month-button--previous" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = {
  key: 1,
  role: "img",
  viewBox: "0 0 1000 1000"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("title", null, "Icon previous month", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", { d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" }, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "asd__change-month-button asd__change-month-button--next" }
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = {
  key: 1,
  role: "img",
  viewBox: "0 0 1000 1000"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("title", null, "Icon next month", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" }, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "asd__month-name" }
const _hoisted_19 = ["onUpdate:modelValue", "tabindex", "onChange"]
const _hoisted_20 = ["value", "disabled"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onUpdate:modelValue", "tabindex", "onChange"]
const _hoisted_23 = ["value"]
const _hoisted_24 = ["value"]
const _hoisted_25 = { key: 3 }
const _hoisted_26 = {
  class: "asd__month-table",
  role: "presentation"
}
const _hoisted_27 = ["data-date", "tabindex", "aria-label", "onMouseover"]
const _hoisted_28 = ["date", "disabled", "onClick"]
const _hoisted_29 = { class: "asd__keyboard-shortcuts-title" }
const _hoisted_30 = ["aria-label"]
const _hoisted_31 = {
  key: 1,
  class: "asd__mobile-close-icon",
  "aria-hidden": "true"
}
const _hoisted_32 = { class: "asd__keyboard-shortcuts-list" }
const _hoisted_33 = ["aria-label"]
const _hoisted_34 = {
  key: 1,
  class: "asd__action-buttons"
}
const _hoisted_35 = {
  key: 2,
  class: "asd__keyboard-shortcuts-trigger-wrapper"
}
const _hoisted_36 = ["aria-label"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "?", -1)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_resize_select = _resolveDirective("resize-select")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Transition, { name: "asd__fade" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        id: _ctx.wrapperId,
        ref: "root",
        class: _normalizeClass(["asd__wrapper", _ctx.wrapperClasses]),
        style: _normalizeStyle(_ctx.showFullscreen ? undefined : _ctx.wrapperStyles)
      }, [
        (_ctx.showFullscreen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                class: "asd__mobile-close",
                "aria-label": _ctx.ariaLabels.closeDatepicker,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDatepicker && _ctx.closeDatepicker(...args)))
              }, [
                (_ctx.$slots['close-icon'])
                  ? _renderSlot(_ctx.$slots, "close-icon", { key: 0 })
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, " X "))
              ], 8, _hoisted_3),
              _createElementVNode("h3", null, _toDisplayString(_ctx.mobileHeader || _ctx.mobileHeaderFallback), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              "aria-label": _ctx.ariaLabels.previousMonth,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previousMonth && _ctx.previousMonth(...args)))
            }, [
              (_ctx.$slots['previous-month-icon'])
                ? _renderSlot(_ctx.$slots, "previous-month-icon", { key: 0 })
                : (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_11))
            ], 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              "aria-label": _ctx.ariaLabels.nextMonth,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
            }, [
              (_ctx.$slots['next-month-icon'])
                ? _renderSlot(_ctx.$slots, "next-month-icon", { key: 0 })
                : (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_17))
            ], 8, _hoisted_13)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showMonths, (month, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: month,
              class: "asd__days-legend",
              style: _normalizeStyle([_ctx.monthWidthStyles, {left: (_ctx.width * index) + 'px'}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysShort, (day, dayIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: dayIndex,
                  class: "asd__day-title"
                }, _toDisplayString(day), 1))
              }), 128))
            ], 4))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "asd__inner-wrapper",
          style: _normalizeStyle(_ctx.innerStyles)
        }, [
          _createVNode(_TransitionGroup, {
            name: "asd__list-complete",
            tag: "div"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, monthIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: month.firstDateOfMonth,
                  class: _normalizeClass(["asd__month", {'asd__month--hidden': monthIndex === 0 || monthIndex > _ctx.showMonths}]),
                  style: _normalizeStyle(_ctx.monthWidthStyles)
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.showMonthYearSelect)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => ((month.monthName) = $event),
                          class: "asd__month-year-select",
                          tabindex: monthIndex === 0 || monthIndex > _ctx.showMonths ? -1 : 0,
                          onChange: ($event: any) => (_ctx.updateMonth(monthIndex, month.year, $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthNames, (monthName, idx) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: `month-${monthIndex}-${monthName}`,
                              value: monthName,
                              disabled: _ctx.isMonthDisabled(month.year, idx)
                            }, _toDisplayString(monthName), 9, _hoisted_20))
                          }), 128))
                        ], 40, _hoisted_19)), [
                          [_vModelSelect, month.monthName],
                          [_directive_resize_select]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(month.monthName), 1)),
                    (_ctx.showMonthYearSelect)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 2,
                          "onUpdate:modelValue": ($event: any) => ((month.year) = $event),
                          class: "asd__month-year-select",
                          tabindex: monthIndex === 0 || monthIndex > _ctx.showMonths ? -1 : 0,
                          onChange: ($event: any) => (_ctx.updateYear(monthIndex, month.monthNumber - 1, $event))
                        }, [
                          (_ctx.years.indexOf(month.year) === -1)
                            ? (_openBlock(), _createElementBlock("option", {
                                key: `month-${monthIndex}-${_ctx.year}`,
                                value: month.year,
                                disabled: true
                              }, _toDisplayString(month.year), 9, _hoisted_23))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (yearOption) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: `month-${monthIndex}-${yearOption}`,
                              value: yearOption
                            }, _toDisplayString(yearOption), 9, _hoisted_24))
                          }), 128))
                        ], 40, _hoisted_22)), [
                          [_vModelSelect, month.year]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(month.year), 1))
                  ]),
                  _createElementVNode("table", _hoisted_26, [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.weeks, (week, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: "asd__week"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, ({fullDate, dayNumber}, weekIndex) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: weekIndex + '_' + dayNumber,
                              ref_for: true,
                              ref: el => { _ctx.dateTds[fullDate] = el },
                              class: _normalizeClass(["asd__day", [{
                                            'asd__day--enabled': dayNumber !== 0,
                                            'asd__day--empty': dayNumber === 0,
                                            'asd__day--disabled': _ctx.isDisabled(fullDate),
                                            'asd__day--selected': fullDate && (_ctx.selectedDate1 === fullDate || _ctx.selectedDate2 === fullDate),
                                            'asd__day--in-range': _ctx.isInRange(fullDate),
                                            'asd__day--today': fullDate && _ctx.isToday(fullDate),
                                            'asd__day--hovered': _ctx.isHoveredInRange(fullDate),
                                            'asd__selected-date-one': fullDate && fullDate === _ctx.selectedDate1,
                                            'asd__selected-date-two': fullDate && fullDate === _ctx.selectedDate2,
                                        }, _ctx.customizedDateClass(fullDate)]]),
                              "data-date": fullDate,
                              tabindex: _ctx.isDateVisible(fullDate) && _ctx.isSameDate(_ctx.focusedDate, fullDate) ? 0 : -1,
                              "aria-label": _ctx.isDateVisible(fullDate) ? _ctx.getAriaLabelForDate(fullDate) : false,
                              style: _normalizeStyle(_ctx.getDayStyles(fullDate)),
                              onMouseover: () => { _ctx.setHoverDate(fullDate) }
                            }, [
                              dayNumber
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "asd__day-button",
                                    type: "button",
                                    tabindex: "-1",
                                    date: fullDate,
                                    disabled: _ctx.isDisabled(fullDate),
                                    onClick: () => { _ctx.selectDate(fullDate) }
                                  }, _toDisplayString(dayNumber), 9, _hoisted_28))
                                : _createCommentVNode("", true)
                            ], 46, _hoisted_27))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ], 6))
              }), 128))
            ]),
            _: 1
          }),
          (_ctx.showShortcutsMenuTrigger)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass({ 'asd__keyboard-shortcuts-menu': true, 'asd__keyboard-shortcuts-show': _ctx.showKeyboardShortcutsMenu}),
                style: _normalizeStyle(_ctx.keyboardShortcutsMenuStyles)
              }, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.texts.keyboardShortcuts), 1),
                _createElementVNode("button", {
                  ref: "keyboardShortcutMenuClose",
                  class: "asd__keyboard-shortcuts-close",
                  tabindex: "0",
                  "aria-label": _ctx.ariaLabels.closeKeyboardShortcutsMenu,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeKeyboardShortcutsMenu && _ctx.closeKeyboardShortcutsMenu(...args)))
                }, [
                  (_ctx.$slots['close-shortcuts-icon'])
                    ? _renderSlot(_ctx.$slots, "close-shortcuts-icon", { key: 0 })
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, " X "))
                ], 8, _hoisted_30),
                _createElementVNode("ul", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keyboardShortcuts, (shortcut, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                      _createElementVNode("span", {
                        class: "asd__keyboard-shortcuts-symbol",
                        "aria-label": shortcut.symbolDescription
                      }, _toDisplayString(shortcut.symbol), 9, _hoisted_33),
                      _createTextVNode(" " + _toDisplayString(shortcut.label), 1)
                    ]))
                  }), 128))
                ])
              ], 6))
            : _createCommentVNode("", true)
        ], 4),
        (_ctx.mode !== 'single' && _ctx.showActionButtons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeDatepickerCancel && _ctx.closeDatepickerCancel(...args)))
              }, _toDisplayString(_ctx.texts.cancel), 1),
              _createElementVNode("button", {
                ref: "applyButton",
                style: _normalizeStyle({color: _ctx.colors.selected}),
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
              }, _toDisplayString(_ctx.texts.apply), 5)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showShortcutsMenuTrigger)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("button", {
                class: "asd__keyboard-shortcuts-trigger",
                "aria-label": _ctx.ariaLabels.openKeyboardShortcutsMenu,
                tabindex: "0",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openKeyboardShortcutsMenu && _ctx.openKeyboardShortcutsMenu(...args)))
              }, _hoisted_38, 8, _hoisted_36)
            ]))
          : _createCommentVNode("", true)
      ], 14, _hoisted_1)), [
        [_vShow, _ctx.showDatepicker],
        [_directive_click_outside, _ctx.handleClickOutside]
      ])
    ]),
    _: 3
  }))
}